import React from "react";
import DiwaliDiya from "./DiwaliDiya";
import "../../../styles/diwaliTheme.css";

/** "Shubh Deepavali" chip with a flickering diya and a gold shine. */
const DiwaliGreeting = () => {
  return (
    <span className="relative inline-flex shrink-0 rounded-full bg-[linear-gradient(135deg,#f59e0b,#fde68a_45%,#ea580c)] p-px shadow-[0_2px_10px_-2px_rgba(234,88,12,0.35)]">
      <span className="relative inline-flex h-7 items-center gap-1 overflow-hidden whitespace-nowrap rounded-full bg-[linear-gradient(135deg,#fffbeb,#fff1dc)] pl-0.5 pr-3">
        <DiwaliDiya idPrefix="diwali-chip-diya" />
        <span className="bg-[linear-gradient(90deg,#b45309,#ea580c,#b45309)] bg-clip-text text-xs font-bold tracking-wide text-transparent">
          Shubh Deepavali
        </span>
        <span
          aria-hidden="true"
          className="diwali-shine pointer-events-none absolute inset-y-0 w-8 -skew-x-12 bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.85),transparent)]"
        />
      </span>
    </span>
  );
};

export default DiwaliGreeting;
